import React from "react";

const LoadingSpinner = ({
  size = "medium",
  message = "Loading...",
  className = "",
  variant = "default",
  showMessage = true,
}) => {
  const sizeClasses = {
    xs: "w-3 h-3",
    small: "w-4 h-4",
    medium: "w-8 h-8",
    large: "w-12 h-12",
    xl: "w-16 h-16",
  };

  const variants = {
    default: "text-vintage-orange",
    vintage: "text-burnt-orange-500",
    light: "text-white",
    dark: "text-sepia-800",
  };

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div
        className={`${sizeClasses[size]} animate-spin`}
        role="status"
        aria-label="Loading"
      >
        <svg
          className={`w-full h-full ${variants[variant]}`}
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      </div>
      {showMessage && message && (
        <p className="mt-4 text-secondary  text-center animate-pulse">
          {message}
        </p>
      )}
    </div>
  );
};

// Full page loading component
export const FullPageLoader = ({ message = "Loading..." }) => {
  return (
    <div className="fixed inset-0 bg-cream-50/80 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg border border-sepia-200 p-8 max-w-sm w-full mx-4">
        <LoadingSpinner
          size="large"
          variant="vintage"
          message={message}
          className="py-4"
        />
      </div>
    </div>
  );
};

// Inline loading component for buttons
export const ButtonLoader = ({ size = "small", className = "" }) => {
  return (
    <LoadingSpinner
      size={size}
      variant="light"
      showMessage={false}
      className={`inline-flex ${className}`}
    />
  );
};

// Loading overlay for components
export const LoadingOverlay = ({
  isLoading,
  message = "Loading...",
  children,
  className = "",
}) => {
  return (
    <div className={`relative ${className}`}>
      {children}
      {isLoading && (
        <div className="absolute inset-0 bg-white/80 backdrop-blur-sm flex items-center justify-center rounded-lg z-10">
          <LoadingSpinner size="medium" variant="vintage" message={message} />
        </div>
      )}
    </div>
  );
};

export default LoadingSpinner;
